var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTavax(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_616_2517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 32C25.3365 32 32.5 24.8365 32.5 16C32.5 7.16344 25.3365 0 16.5 0C7.66344 0 0.5 7.16344 0.5 16C0.5 24.8365 7.66344 32 16.5 32Z",
    fill: "#8D91AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0545 16.2333C21.5015 15.4201 22.223 15.4201 22.67 16.2333L25.4543 21.3805C25.9014 22.1938 25.5356 22.8572 24.6414 22.8572H19.0324C18.1484 22.8572 17.7825 22.1938 18.2195 21.3805L21.0545 16.2333ZM15.669 6.32432C16.1161 5.51104 16.8275 5.51104 17.2745 6.32432L17.8943 7.5014L19.3575 10.2087C19.7132 10.9792 19.7132 11.8888 19.3575 12.6592L14.4497 21.6159C14.0026 22.3436 13.2608 22.8037 12.4377 22.8572H8.36308C7.46891 22.8572 7.1031 22.2044 7.55019 21.3805L15.669 6.32432Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_616_2517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTavax);
export default __webpack_public_path__ + "static/media/tavax.11bde085be26d12f0677d2717846c0e0.svg";
export { ForwardRef as ReactComponent };